"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _hostUtils = require("./utils/host-utils");
var availableLanguages;
try {
  availableLanguages = require("./translations/availableLanguages.json");
} catch (err) {
  availableLanguages = [];
}
var _default = exports["default"] = {
  placeholderImageUrl: (0, _hostUtils.localiseHostName)('https://res.cloudinary.com/swipe-guide-eu/image/upload/v1490354588/placeholder-image.jpg'),
  availableLanguages: availableLanguages,
  allowedPersistentQueryParameters: ['embed', 'isolatedInstruction']
};
//# sourceMappingURL=config.js.map